import React from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "../components/ShadeDialog";
import PayoutViewV2 from './PayoutViewV2';
import { Board } from '../utils/Primitives';

type PayoutReviewerProps = {
  isOpen: boolean;
  boardRef: React.MutableRefObject<Board>;
  onClose: () => void;
};

export default function PayoutReviewer({
  isOpen,
  boardRef,
  onClose,
}: PayoutReviewerProps) {
  if (!isOpen) {
    return null;
  }

  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className='bg-white text-slate-900 p-4'>
        <DialogHeader>
          <DialogTitle>Publisher Payouts</DialogTitle>
          <PayoutViewV2
            handleDidClose={onClose}
            boardRef={boardRef}
            isModal={true}
          />
        </DialogHeader>
      </DialogContent>
    </Dialog>
  );
}